import Axios from 'axios';
import { getRequestToken, onRequestTokenUpdate } from '@nextcloud/auth';
import { generateUrl } from '@nextcloud/router';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var RETRY_KEY = Symbol('csrf-retry');
var onError$2 = function (axios) { return function (error) { return __awaiter(void 0, void 0, void 0, function () {
    var config, response, request, responseURL, status, token;
    var _a;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = error.config, response = error.response, request = error.request;
                responseURL = request === null || request === void 0 ? void 0 : request.responseURL;
                status = response === null || response === void 0 ? void 0 : response.status;
                if (!(status === 412
                    && ((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.message) === 'CSRF check failed'
                    && config[RETRY_KEY] === undefined)) return [3 /*break*/, 2];
                console.warn("Request to ".concat(responseURL, " failed because of a CSRF mismatch. Fetching a new token"));
                return [4 /*yield*/, axios.get(generateUrl('/csrftoken'))];
            case 1:
                token = (_c.sent()).data.token;
                console.debug("New request token ".concat(token, " fetched"));
                axios.defaults.headers.requesttoken = token;
                return [2 /*return*/, axios(__assign(__assign({}, config), (_a = { headers: __assign(__assign({}, config.headers), { requesttoken: token }) }, _a[RETRY_KEY] = true, _a)))];
            case 2: return [2 /*return*/, Promise.reject(error)];
        }
    });
}); }; };

var RETRY_DELAY_KEY = Symbol('retryDelay');
var onError$1 = function (axios) { return function (error) { return __awaiter(void 0, void 0, void 0, function () {
    var config, response, request, responseURL, status, headers, retryDelay_1;
    var _a;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = error.config, response = error.response, request = error.request;
                responseURL = request === null || request === void 0 ? void 0 : request.responseURL;
                status = response === null || response === void 0 ? void 0 : response.status;
                headers = response === null || response === void 0 ? void 0 : response.headers;
                if (!(status === 503
                    && headers['x-nextcloud-maintenance-mode'] === '1'
                    && config.retryIfMaintenanceMode
                    && (!config[RETRY_DELAY_KEY] || config[RETRY_DELAY_KEY] <= 32))) return [3 /*break*/, 2];
                retryDelay_1 = ((_b = config[RETRY_DELAY_KEY]) !== null && _b !== void 0 ? _b : 1) * 2;
                console.warn("Request to ".concat(responseURL, " failed because of maintenance mode. Retrying in ").concat(retryDelay_1, "s"));
                return [4 /*yield*/, new Promise(function (resolve) {
                        setTimeout(resolve, retryDelay_1 * 1000);
                    })];
            case 1:
                _c.sent();
                return [2 /*return*/, axios(__assign(__assign({}, config), (_a = {}, _a[RETRY_DELAY_KEY] = retryDelay_1, _a)))];
            case 2: return [2 /*return*/, Promise.reject(error)];
        }
    });
}); }; };

var onError = function (error) { return __awaiter(void 0, void 0, void 0, function () {
    var config, response, request, responseURL, status;
    var _a;
    return __generator(this, function (_b) {
        config = error.config, response = error.response, request = error.request;
        responseURL = request === null || request === void 0 ? void 0 : request.responseURL;
        status = response === null || response === void 0 ? void 0 : response.status;
        if (status === 401
            && ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message) === 'Current user is not logged in'
            && config.reloadExpiredSession
            && (window === null || window === void 0 ? void 0 : window.location)) {
            console.error("Request to ".concat(responseURL, " failed because the user session expired. Reloading the page \u2026"));
            window.location.reload();
        }
        return [2 /*return*/, Promise.reject(error)];
    });
}); };

var _a;
var client = Axios.create({
    headers: {
        requesttoken: (_a = getRequestToken()) !== null && _a !== void 0 ? _a : '',
    },
});
var cancelableClient = Object.assign(client, {
    CancelToken: Axios.CancelToken,
    isCancel: Axios.isCancel,
});
cancelableClient.interceptors.response.use(function (r) { return r; }, onError$2(cancelableClient));
cancelableClient.interceptors.response.use(function (r) { return r; }, onError$1(cancelableClient));
cancelableClient.interceptors.response.use(function (r) { return r; }, onError);
onRequestTokenUpdate(function (token) { client.defaults.headers.requesttoken = token; });

export { cancelableClient as default };
//# sourceMappingURL=index.es.mjs.map
